const tab_sections = {
    identity: 'ID と組織',
    integrations: 'アプリと接続',
    login_security: 'ログインとセキュリティ',
    permissions: '権限とリソース',
    automation: '自動化と監査',
    platform: 'プラットフォーム',
    overview: '概要',
    authentication: '認証',
    authorization: '認可',
    users: 'ユーザー',
    developer: '開発者',
    tenant: 'テナント',
};
export default Object.freeze(tab_sections);
